/*
<summary>
   This functional component wraps its children in a ".card card-page" box, unless
   `embedded` is true - in which case it renders the children directly, since the host page
   already supplies that card.
   Developer: Aashish Singh, Created Date: 01-Sep-2026
</summary>
<param>embedded: When true, renders children without the card wrapper</param>
<returns>Returns JSX</returns>
*/

import React from 'react';

interface IProps {
  embedded: boolean;
  children: React.ReactNode;
}

const CardWrapper = ({ embedded, children }: IProps) =>
  embedded ? <>{children}</> : <div className="card card-page">{children}</div>;

export default CardWrapper;
